export default "__VITE_ASSET__Fal9RREX__"